import React, { Component } from 'react';
import { Trans } from "@lingui/react";
import styled from 'styled-components';
import Label from './../../../components/form/Label';
import { Box, Flex } from './../../../components/layout/Grid';

const Select = styled.select`
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  font-size: 16px;
  padding: 10px 0px;
`;

class TimePicker extends Component {
  constructor(props) {
    super(props);
    const times = () => {
      let t = [];
      for (let i = 0; i < 24; i++) {
        let h = i.toString();

        if (h.length === 1) {
          t.push({ h: h, time: `0${h}:00`, zulu: `0${h}00` });
          t.push({ h: h, time: `0${h}:30`, zulu: `0${h}30` });
        } else {
          t.push({ h: h, time: `${h}:00`, zulu: `${h}00` });
          t.push({ h: h, time: `${h}:30`, zulu: `${h}30` });
        }
      }

      return t;
    };

    this.state = {
      times: times(),
      startTime: '1700',
    };
  }

  handleTime = e => {
    this.setState({ startTime: e.target.value }, () => {
      this.props.handleChange(this.state.startTime);
    });
  };

  render() {
    return (
      <Flex alignItems="center">
        <Box>
          <Label>
            <Trans id="schedule_modal.time" message={'Time'} />:
          </Label>
        </Box>
        <Box ml={10}>
          <Select onChange={this.handleTime} value={this.state.startTime}>
            {this.state.times.map((time, i) => {
              return (
                <option key={i} value={time.zulu}>
                  {time.time}
                </option>
              );
            })}
          </Select>
        </Box>
      </Flex>
    );
  }
}

export default TimePicker;
